// frontend/src/components/OrdersPage/OrderFinances/components/CommissionPaymentRow.jsx

import React from "react";
import Button from "../../../UI/Button";
import {
  formatDate,
  formatPaymentStatus,
  formatCommissionAmount,
  getDocumentUrl,
} from "../utils";

export default function CommissionPaymentRow({
  commission,
  onOpenPayment,
}) {
  const hasPayment = commission.accounting_record != null;

  return (
    <tr className="border-b bg-blue-50 align-top transition-colors duration-150 hover:bg-blue-100">
      <td className="p-3 font-semibold text-blue-700">
        Комиссионное вознаграждение
        <div className="mt-1 text-xs font-normal">
          {hasPayment
            ? `Accounting №${commission.accounting_record}`
            : "Без привязки к платежу"}
        </div>
        {commission.order_code && (
          <div className="mt-1 text-xs font-normal text-gray-600">
            Заказ: {commission.order_code}
          </div>
        )}
        {commission.account_name && (
          <div className="mt-1 text-xs font-normal text-gray-600">
            Счёт: {commission.account_name}
          </div>
        )}
      </td>

      <td className="p-3">{formatDate(commission.date)}</td>

      <td className="p-3 font-semibold text-blue-700">
        {formatCommissionAmount(commission)}
      </td>

      <td className="p-3">{commission.payment_agent || "—"}</td>

      <td className="p-3 whitespace-pre-wrap">
        {commission.comment || "—"}
      </td>

      <td className="p-3">
        <div>{formatPaymentStatus(commission.payment_status)}</div>

        {commission.documents?.length > 0 ? (
          <div className="mt-2 space-y-1">
            {commission.documents.map((document) => {
              const url = getDocumentUrl(document);
              return url ? (
                <div key={document.id}>
                  <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-700 underline"
                  >
                    {document.original_name || `Документ ${document.id}`}
                  </a>
                </div>
              ) : null;
            })}
          </div>
        ) : (
          <span className="text-gray-500">Нет документов</span>
        )}
      </td>

      <td className="p-3">
        {hasPayment ? (
          <Button
            className="px-2 py-1 text-xs"
            variant="primary"
            onClick={() => onOpenPayment(commission.accounting_record)}
          >
            Перейти к платежу
          </Button>
        ) : (
          <span className="text-xs text-gray-500">Нет привязки</span>
        )}
      </td>
    </tr>
  );
}